export const DEPOSIT_TYPES = Object.freeze({
  CASH: 'cash',
  CARD: 'card',
  ONLINE: 'online',
  SLICK_POS: 'slick_pos',
  OTHER: 'other',
});

export const DEPOSIT_TYPE_TRANSLATION_KEYS = Object.freeze({
  [DEPOSIT_TYPES.CASH]: 'cashUp.cashupLogs.depositItems.cash',
  [DEPOSIT_TYPES.CARD]: 'cashUp.cashupLogs.depositItems.cardInStore',
  [DEPOSIT_TYPES.ONLINE]: 'cashUp.cashupLogs.depositItems.cardOnline',
  [DEPOSIT_TYPES.SLICK_POS]: 'cashUp.cashupLogs.depositItems.cardSlickPay',
  [DEPOSIT_TYPES.OTHER]: 'cashUp.cashupLogs.depositItems.other',
});
